"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/* eslint-env browser */
const React = tslib_1.__importStar(require("react"));
// SplashMessage sets the info message in the splash screen
// We assume only one SplashMessage will be mounted at a time and in correct order
class SplashMessage extends React.Component {
    componentDidMount() {
        const element = document.getElementById("mne-splash-text");
        if (!element)
            return;
        element.innerText = this.props.text;
    }
    render() {
        return null;
    }
}
exports.default = SplashMessage;
